import React, { forwardRef } from 'react';
import { useRef } from 'react';

import { MobileAfterUserChoosePage } from './MobileAfterUserChoosePage';
import { MobileAfterUserChoosePageContainerProps } from './types';

const MobileAfterUserChoosePageContainer = forwardRef<HTMLDivElement, MobileAfterUserChoosePageContainerProps>(({ onGetResultHandler, friend }) => {

  const afterUserChooseRef = useRef<HTMLDivElement>(null);

  return (
    <MobileAfterUserChoosePage
      ref={afterUserChooseRef}
      friend={friend}
      onGetResultHandler={onGetResultHandler}
      delayAnimation={0.2}
    />
  );
});

export default MobileAfterUserChoosePageContainer;
